import { err, ok } from 'neverthrow';
import { AST } from '../../../ast';
import { CompileOutput, ParseError, ParseRes } from '../../eraql-ast/ast';
import { TokenMeta, WithMeta } from '../../lex';
import { Expression } from '../../../builder/expression';

export const tryTypeCheckExpr = (
  expr: AST.ExprFR,
  meta: TokenMeta
): ParseRes<CompileOutput> => {
  const exprRes = Expression.tryfromAst(expr);
  if (exprRes.isOk()) {
    return ok({ item: { t: 'expr', expr: exprRes.value }, bindings: {} });
  } else {
    const e: WithMeta<ParseError> = [
      { t: 'type-check-error', trace: exprRes.error },
      meta,
    ];
    return err([e]);
  }
};
